import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["drawer", "openButton", "closeButton"];

  connect() {
    this.openButtonTarget.addEventListener("click", this.open.bind(this));
    this.closeButtonTarget.addEventListener("click", this.close.bind(this));
  }

  disconnect() {
    this.openButtonTarget.removeEventListener("click", this.open.bind(this));
    this.closeButtonTarget.removeEventListener("click", this.close.bind(this));
  }

  open(e) {
    e.preventDefault();
    this.drawerTarget.classList.add("is-opened");
    document.body.classList.add("is-drawer-opened");
  }

  close(e) {
    e.preventDefault();
    this.drawerTarget.classList.remove("is-opened");
    document.body.classList.remove("is-drawer-opened");
  }
}
